import React, { useState } from 'react';
import { FaEye } from "react-icons/fa";
import { IoMdEyeOff } from "react-icons/io";

const Input = ({
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  error,
  disabled = false,
  icon,
  showPasswordToggle = false,
  className = '',
  id,
  name,
  maxLength,
  pattern,
  onBlur
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputType = showPasswordToggle ? (showPassword ? 'text' : 'password') : type;
  
  const handleInputChange = (e) => {
        if ((type === 'number' || type === 'tel') && e.target.value) {
      const numericValue = e.target.value.replace(/[^0-9]/g, '');
      e.target.value = numericValue;
    }
    onChange(e);
  };
  
  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label 
          htmlFor={id} 
          className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      
      <div className="relative">
        <input
          id={id}
          name={name}
          type={inputType}
          value={value}
          onChange={handleInputChange}
          onBlur={onBlur}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          maxLength={maxLength}
          pattern={pattern}
          className={`
            w-full px-4 py-2 rounded-lg 
            border ${error ? 'border-red-500' : 'border-gray-300 dark:border-slate-600'}
            bg-gray-50 dark:bg-slate-700 text-xs sm:text-sm
            text-gray-900 dark:text-white 
            placeholder-gray-400 dark:placeholder-gray-500
            focus:ring-2 focus:ring-primary focus:border-transparent 
            transition-all duration-200 outline-none
            disabled:opacity-50 disabled:cursor-not-allowed
            ${icon || showPasswordToggle ? 'pr-10' : ''}
          `}
        />
                {showPasswordToggle && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            {showPassword ? <IoMdEyeOff className="w-5 h-5" /> : <FaEye className="w-5 h-5" />}
          </button>
        )}
        
        {icon && !showPasswordToggle && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
            {icon}
          </div>
        )}
      </div>
      
      {error && (
        <p className="mt-1 text-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

export default Input;
